import React from 'react';

// Fake browser-chrome wrapper used to frame the portal preview and the embed
// widget preview as "what your customers see" on an external site.
export default function BrowserFrame({ url, children }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
      <div className="flex items-center gap-2 px-3 py-2 bg-slate-100 border-b border-slate-200">
        <span className="flex gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
          <span className="w-2.5 h-2.5 rounded-full bg-amber-400" />
          <span className="w-2.5 h-2.5 rounded-full bg-green-400" />
        </span>
        <div className="flex-1 mx-2 bg-white border border-slate-200 rounded-md px-3 py-1 text-[11px] text-slate-500 truncate font-mono">
          {url}
        </div>
      </div>
      <div className="bg-slate-50/60">{children}</div>
    </div>
  );
}
